<ms-showcase *ngIf="hasData" [moduleData]="module" (showcaseDataLoaded)="showcaseDataLoaded()"> </ms-showcase>
